import { IUser } from "../../store";

export const localStorageKey = (key: string, user?: IUser, customer?: string) =>
  `ECOD-${user ? `${user.loginEmail}` : "anyone"}-${key}${customer ? `-${customer}` : ""}`;
